import React, { Component } from 'react'
import get from 'lodash/get'
import VideoPlayer from './videoPlayer'
import BuriedPoint from '../../../utils/log'
import { openApp, buildUniversalLink, consumeIosPending, APP_STORE_URL, wechatDownloadUrl } from '../openApp'
import { formatCount } from '../formatCount'
import { getVisitorId } from '../visitorId'
import appLogo from './images/app-logo.png'
import focusIcon from './images/focus-icon.png'
// 失效态图标(设计稿「视频-4」切图 17715D2D,140×140@2x → 70px)。圆底是烘焙进图里的
// rgba(255,255,255,.125),所以贴在页面底色 #1C1E22 上直接就是稿子里那个灰圆,不用另画底板。
import offlineIcon from './images/offline-icon.png'
import wechatGuideImg from './images/wechat-guide.png'
// 点赞图标直接用 App 那张(needle2020 tiktok/videoLayer/assets/icon-like.png):
// 它把 rgba(0,0,0,0.30) 的圆形底板烘焙在图里,与设计稿 /点赞/good/矩形 的填充一致。
import likeIcon from './images/like-icon.png'

/**
 * 视频分享落地页(TAPD 1006913)
 *
 * 布局照 UI/ui_h5.png(750×1624@2x → 375×812pt,下面的数值都已 /2),
 * 但按需求文档口径做了三处修正(需求「三·(四)分享落地页」):
 *   - 砍掉评论数。需求原话「评论、送礼在 H5 不展示、不可用,引导回 App」(UI 画了 42)
 *   - 加作者身份文字(authorTitle,如「主治医师」)
 *   - 补视频标题。需求「标题与简介:视频标题 + 简介文本」要求标题**显示在页面上**;
 *     UI 稿里标题只出现在微信导航栏(即 document.title),照 UI 做会漏掉页面上这份
 * 点赞数只读:落地页不做点赞,也不做关注 —— 头像上的 + 角标点了走"打开 App"引导。
 */
// PV 与 document.title 由容器层在数据到手后处理(见 ../index.js),这里只管交互埋点
// OPEN_APP_CLICK 的名字取自 TAPD 1006913 评论区的埋点规范;
// UNMUTE 是规范外多报的一条(点击开声音),同一套命名风格
// 吸底胶囊的宽度。页面 CTA 与微信引导里那个下载按钮**共用**它 ——
// 引导蒙层弹出时后者正压在前者上,差一点点就会在边缘漏出一圈被压暗的绿色。
// 251 是原 CTA(minWidth 219 + logo 28 + 间距 10 + 左右 padding 32 + 文字)的实测渲染宽度,
// 改成定宽后它的视觉尺寸不变。
const CTA_WIDTH = 251

const EVENT = {
  OPEN_APP_CLICK: 'VIDEO_SHARE_OPEN_APP_CLICK',
  UNMUTE: 'VIDEO_SHARE_UNMUTE',
}

// 加载态推迟这么久才露面。它是给弱网下那几秒黑屏兜底的(见 render 里的注释),
// 而 pigeon 在正常网络下 100~300ms 就应答了 —— 不推迟的话,加载态的 appLogo
// 会在失效/正常态到来前白闪一下,比它要解决的黑屏更难看。
// 300ms 卡在"人眼基本察觉不到"和"弱网下别让用户等太久才看见反馈"中间。
const LOADING_DELAY = 300

class VideoShare extends Component {
  state = {
    // 'wechat' = 微信内引导蒙层;'appstore' = iOS 没唤起成功,给 App Store 入口
    guide: null,
    // 加载态是否已经可以露面,见 LOADING_DELAY
    loadingVisible: false,
  }

  track = (eventName, extra) => {
    BuriedPoint.saLog(eventName, {
      id: getVisitorId(),
      payload: { videoId: this.props.videoId, visitorId: getVisitorId(), ...extra },
    })
  }

  componentDidMount() {
    // 上次点了「打开 App」但又回到了本页 = 没装 App(universal link 没被 iOS 拦下,
    // 于是 gateway 把我们 302 了回来,页面重载把当时的定时器也一起冲掉了)。
    if (consumeIosPending()) this.setState({ guide: 'appstore' })
    // 数据已经到了就别再 setState —— 那一下不会改变画面(loading 为 false 时压根不读
    // loadingVisible),却会让整页白白重渲染一次,而这 300ms 正是播放器在初始化、
    // 抢自动播的时候。
    this.loadingTimer = setTimeout(() => {
      if (this.props.loading) this.setState({ loadingVisible: true })
    }, LOADING_DELAY)
  }

  componentWillUnmount() {
    clearTimeout(this.loadingTimer)
  }

  /**
   * @param e        点击事件(CTA 是 <a> 时才有)
   * @param viaLink  从 CTA 那个 <a href={universal link}> 点进来的
   */
  onOpenApp = (e, viaLink = false) => {
    const branch = openApp({
      videoId: this.props.videoId,
      viaLink,
      onWechatTip: () => this.setState({ guide: 'wechat' }),
      onNeedStore: () => this.setState({ guide: 'appstore' }),
    })
    // 只有 iOS 那条放行 <a> 的默认跳转 —— 让浏览器原生跟随链接,universal link 才触发得稳。
    // 其余分支(微信内弹引导、安卓走 scheme、桌面去应用宝)openApp 内部已经处理完了,
    // 再让链接跳一次会把用户送到 gateway 上白跑一趟。
    if (e && e.preventDefault && branch !== 'ios_universal_link') e.preventDefault()
    this.track(EVENT.OPEN_APP_CLICK, { branch })
  }

  closeGuide = () => this.setState({ guide: null })

  renderGuide() {
    const { guide } = this.state
    if (!guide) return null

    return (
      <div style={styles.guideMask} onClick={this.closeGuide}>
        {guide === 'wechat' ? (
          <div style={styles.wechatGuide} onClick={e => e.stopPropagation()}>
            {/* 整张稿直接渲染,不再拆成"箭头+图标+文字"重排。
                拆开重排试过三版都对不上 —— 难点在**比例**:稿里 箭头高:标题字高 = 137:39 ≈ 3.5,
                而用系统字体拼出来怎么调都是 4.5 上下(PingFang 的字面比稿里那套窄体黑体小一圈),
                只要箭头缩到"看着不大",文字就显得太小,整体就散了。
                整图渲染把这层关系一次性锁死。
                宽度 366 是被两个约束定死的:箭头要贴右上角(right:0)、文字要落在 24 的左边距上,
                所以 366 = 390 - 24;高度按原图 542×245 的比例得 165。
                ⚠️ 代价:文字成了位图,3x 屏上会略软。要更锐就让设计导 @2x/@3x 切图替换本文件。 */}
            <img src={wechatGuideImg} alt="点击右上角选择浏览器打开" style={styles.wechatGuideImg} />
            {/* 父容器是绝对定位、没有文档流,按钮得自己定位到图的下方 */}
            <div style={styles.wechatGuideBtnWrap}>
              {/* 结构与页面吸底 CTA 完全一致(同样的 styles.cta + logo + 文字),
                  这样它压在 CTA 上时边沿严丝合缝,不会漏出后面那颗被蒙层压暗的绿胶囊 */}
              <div
                style={styles.cta}
                onClick={() => {
                  // iOS 去 App Store、安卓去应用宝,判定在 openApp.js 的 wechatDownloadUrl
                  const url = wechatDownloadUrl()
                  this.track(EVENT.OPEN_APP_CLICK, { branch: url === APP_STORE_URL ? 'wechat_appstore' : 'wechat_yingyongbao' })
                  window.location.href = url
                }}
              >
                <img src={appLogo} alt="" style={styles.ctaLogo} />
                <span style={styles.ctaText}>还没有 App?点此下载</span>
              </div>
            </div>
          </div>
        ) : (
          <div style={styles.guideBox} onClick={e => e.stopPropagation()}>
            <div style={styles.guideTitle}>还没有安装共同照护 App</div>
            <div style={styles.guideText}>安装后即可直接打开这条视频,还能看更多控糖科普</div>
            <div
              style={styles.guideBtn}
              onClick={() => {
                this.track(EVENT.OPEN_APP_CLICK, { branch: 'ios_appstore' })
                window.location.href = APP_STORE_URL
              }}
            >
              去 App Store 下载
            </div>
          </div>
        )}
      </div>
    )
  }

  renderUnavailable() {
    // 网络/服务没应答与"视频真的没了"是两回事。都说「该视频已下架」的话,网络抖一下
    // 用户就以为内容被删了 —— 而它下次刷新很可能就好了。业务上的四种失效原因
    // (NOT_FOUND / OFFLINE / SHARE_DISABLED / NO_VIDEO_SOURCE)仍共用后端那一句,
    // 不对外泄露某个 id 到底存不存在。
    const isNetwork = this.props.reason === 'NETWORK'
    const message = isNetwork ? '加载失败，请检查网络后重试' : this.props.message || '该视频已下架'
    const sub = isNetwork ? '网络恢复后刷新页面即可' : '去共同照护 App 看看其它控糖科普吧'
    return (
      <div style={styles.page}>
        <div style={styles.offlineBox}>
          <img src={offlineIcon} alt="" style={styles.offlineIcon} />
          <div style={styles.offlineText}>{message}</div>
          <div style={styles.offlineSub}>{sub}</div>
        </div>
        <div style={styles.ctaWrap}>
          <a
            href={buildUniversalLink(this.props.videoId)}
            style={styles.cta}
            onClick={e => this.onOpenApp(e, true)}
          >
            <img src={appLogo} alt="" style={styles.ctaLogo} />
            <span style={styles.ctaText}>打开 App 看更多科普</span>
          </a>
        </div>
        {this.renderGuide()}
      </div>
    )
  }

  render() {
    const { loading, data } = this.props
    if (loading) {
      // 加载态复用失效态的排版零件(offlineBox/offlineSub),不再留纯黑屏。微信里点开卡片
      // 到 pigeon 应答之间弱网下能有好几秒,纯黑会被当成链接坏了直接退出 —— 人走了、
      // PV/UV 也就没了。
      // 但它只该在**真的等起来了**的时候出现:正常网络下 pigeon 几百毫秒就回,立刻画出来
      // 只会让 appLogo 白闪一下再被失效/正常态顶掉。所以头 LOADING_DELAY 毫秒只铺底色,
      // 快路径上用户全程看不到这一屏。
      // 图标这里**必须还是 appLogo**,不能跟着失效态换成 offlineIcon:那个圆圈加斜杠是
      // 「这视频没了」的意思,挂在还在加载的页面上等于先给用户判了死刑。
      // UI 稿没画 loading 态,想要骨架屏得另找设计;这里先给个不用画图的兜底。
      if (!this.state.loadingVisible) return <div style={styles.page} />
      return (
        <div style={styles.page}>
          <div style={styles.offlineBox}>
            <img src={appLogo} alt="" style={styles.loadingLogo} />
            <div style={styles.offlineSub}>加载中…</div>
          </div>
        </div>
      )
    }
    if (!data) {
      return this.renderUnavailable()
    }

    const author = get(data, 'author') || {}
    const authorTitle = get(author, 'authorTitle', '')

    return (
      <div style={styles.page}>
        <VideoPlayer src={get(data, 'videoUrl')} poster={get(data, 'avatar')} onUnmute={() => this.track(EVENT.UNMUTE)} />

        {/* 底部渐变:压住视频保证文字可读(UI 稿的下遮罩,375×360) */}
        <div style={styles.bottomGradient} />

        {/* 右侧:作者头像(+关注角标)+ 只读点赞数 */}
        <div style={styles.rail}>
          {/* 头像/关注角标点击 = 走"打开 App"引导。**必须和吸底 CTA 一样是 <a> + viaLink**:
              iOS 上只有用户直接点链接才能稳定触发 universal link,JS 改 location 各版本行为
              不一(见 openApp.js 的 @param viaLink)。写成 div+onClick 的话 iOS 会真的把
              gateway 地址加载掉 → 302 回本页 → 页面重载 → 弹出"你还没装 App"。 */}
          <a
            href={buildUniversalLink(this.props.videoId)}
            style={styles.avatarWrap}
            onClick={e => this.onOpenApp(e, true)}
          >
            {author.avatar ? <img src={author.avatar} alt="" style={styles.avatar} /> : <div style={styles.avatar} />}
            <img src={focusIcon} alt="" style={styles.followBadge} />
          </a>
          <div style={styles.likeWrap}>
            <img src={likeIcon} alt="" style={styles.likeIcon} />
            {/* 与 App 同一套计数口径,否则热门视频这里会原样显示 12345、还挤破右侧栏 */}
            <div style={styles.likeCount}>{formatCount(get(data, 'votes', 0))}</div>
          </div>
        </div>

        {/* 左下:作者昵称 + 身份 + 标题 + 简介 */}
        <div style={styles.info}>
          <div style={styles.nameRow}>
            <span style={styles.nickname}>@{author.nickname || '共同照护'}</span>
            {!!authorTitle && <span style={styles.authorTitle}>{authorTitle}</span>}
          </div>
          {!!get(data, 'title') && <div style={styles.videoTitle}>{data.title}</div>}
          {!!get(data, 'desc') && <div style={styles.desc}>{data.desc}</div>}
        </div>

        <div style={styles.ctaWrap}>
          <a
            href={buildUniversalLink(this.props.videoId)}
            style={styles.cta}
            onClick={e => this.onOpenApp(e, true)}
          >
            <img src={appLogo} alt="" style={styles.ctaLogo} />
            <span style={styles.ctaText}>打开 App 看更多科普</span>
          </a>
        </div>

        {this.renderGuide()}
      </div>
    )
  }
}

export default VideoShare

const styles = {
  page: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: '#000000',
    overflow: 'hidden',
    WebkitTapHighlightColor: 'transparent',
    // 黑体字体栈(2026-09-10 补)。本模块原先一处 font-family 都没声明,用的是浏览器默认字体 ——
    // 开发机是 macOS 恰好有 PingFang 才看着正常,换到没有 PingFang 的安卓机 / 微信 X5 上
    // 落到什么字体全看设备。这份栈与同仓其它页面一致(见 knowledge/components/KnowledgeListItem.js),
    // 设计稿指定的也正是 PingFang SC。
    // font-family 是可继承属性,挂在 page 上,三种状态(加载/失效/正常)的所有文字都跟着走。
    fontFamily:
      '"PingFang SC", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", Helvetica, Arial, "Hiragino Sans GB", "Source Han Sans", "Noto Sans CJK SC", "Microsoft YaHei", "Microsoft JhengHei", sans-serif',
  },
  bottomGradient: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: '44%',
    background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.75) 100%)',
    pointerEvents: 'none',
  },
  // 右侧栏:UI 稿 x=321pt(距右 10pt),头像在点赞上方 60pt
  rail: {
    position: 'absolute',
    right: 10,
    // 与左侧信息区**底对齐**,取值跟着 styles.info 的 bottom 走(2026-09-10 定)。
    //
    // 设计稿(design_h5.json,画板 375×812pt)里两列本来就是底对齐的:左边简介底边距底 120,
    // 右边最下面那项(评论数「42」)距底 124。但落地页砍掉了评论那组(不展示评论数),
    // rail 的下边缘就变成了点赞数 —— 若仍按设计稿里点赞数自己的位置(距底 208)锚定,
    // 右列就会整体吊在左列上方 68pt,对齐关系丢失。所以这里改为对齐左列底边。
    //
    // ⚠️ 与 styles.info 的 bottom 是一对,改一个要改另一个,否则又错开。
    bottom: 140,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatarWrap: {
    position: 'relative',
    width: 44,
    height: 44,
    // 设计稿:头像底 524 → 点赞底板顶 540,间距 16。
    // (原先是 34,那是配 25pt 裸图标时的值;换成 44 的带底板图标后要收回来,
    //  否则整栈从 124 长到 143,底对齐会被顶掉)
    marginBottom: 16,
    // 它是 <a>(理由见渲染处),默认 inline 撑不出 44×44,也别吃浏览器链接色/下划线
    display: 'block',
    textDecoration: 'none',
    color: '#FFFFFF',
  },
  avatar: {
    width: 44,
    height: 44,
    // ⚠️ border-box 不能去(2026-09-10 真机发现):默认的 content-box 会把 2px 白边加在
    // 44 之外,实际渲染成 48×48。后果有两个,当时看着像两个不相干的毛病:
    //   ① 圆角 22 对 48 的盒子不够(要 24),四个角是方的 —— 头像"不圆"
    //   ② 角标的 left 是按 avatarWrap 的 44 宽算的居中,而头像视觉上占 48,偏左 2px
    boxSizing: 'border-box',
    // 用 50% 而不是写死 22:将来谁改了尺寸或边宽,它还是正圆
    borderRadius: '50%',
    border: '2px solid #FFFFFF',
    background: '#333333',
    objectFit: 'cover',
    display: 'block',
  },
  // 关注角标。**几何与图都照搬 App**(needle2020 VideoElementPage.js 的 focus_icon):
  // 20×20、left 12、bottom -10。原先这里是 CSS 画圆 + 文字 "+",两个毛病:
  //   ① 尺寸只有 16,比 App 小一圈
  //   ② "+" 的墨迹在字体里是压在数学轴上的,不在行盒正中,各机型字体还不一样 ——
  //      flex 居中对齐的是行盒不是墨迹,所以怎么调都还是"看着没居中"
  // 换成 App 那张自带橙底白十字的图,这两件事一起没了。
  followBadge: {
    position: 'absolute',
    left: 12, // (44 - 20) / 2,头像 border-box 44 宽时这就是正中
    bottom: -10, // 角标中心正好压在头像下沿,与 App 一致
    width: 20,
    height: 20,
    display: 'block',
  },
  likeWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  likeIcon: {
    // 44 而不是 25:这张图自带圆形底板,对应设计稿 /点赞/good 那个 44×44 的框,
    // 25 是框里那个纯图标的尺寸。App 也是按 44 渲染(IconButton 的 size 默认值)。
    width: 44,
    height: 44,
    // 不要加 opacity:App 没有,加了会把底板和图标一起调淡,和同栏头像对不上
  },
  likeCount: {
    marginTop: 4, // 设计稿:点赞底板底 584 → 数字顶 588
    color: '#FFFFFF',
    fontSize: 13,
    textShadow: '0 1px 2px rgba(0,0,0,0.3)',
  },
  // 左下信息区:UI 稿 x=10pt,昵称 18pt,简介 14pt 三行截断
  info: {
    position: 'absolute',
    left: 10,
    right: 70,
    // ⚠️ 与 styles.rail 的 bottom 是一对(右侧栏与本区底对齐),改这里要同步改那里。
    bottom: 140, // 设计稿:简介底边距画板底 145pt(在 CTA 之上,不打架)
  },
  nameRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  nickname: {
    color: '#FFFFFF',
    fontSize: 18,
    fontWeight: 500,
  },
  authorTitle: {
    marginLeft: 8,
    padding: '1px 6px',
    borderRadius: 4,
    background: 'rgba(255,255,255,0.22)',
    color: '#FFFFFF',
    fontSize: 12,
  },
  // 视频标题:比昵称小一号但加粗,压在简介上面。
  // 最多三行 —— 与 App 视频页同一位置对齐(VideoElementPage 的 titleDesc
  // 是 numberOfLines={3},那里渲染的也正是 title)。落地页要的就是复刻 App 的观感。
  videoTitle: {
    marginTop: 10,
    color: '#FFFFFF',
    fontSize: 16,
    lineHeight: '22px',
    fontWeight: 600,
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    overflow: 'hidden',
  },
  desc: {
    marginTop: 6,
    color: 'rgba(255,255,255,0.85)',
    fontSize: 14,
    lineHeight: '20px',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    overflow: 'hidden',
  },
  // 吸底 CTA:UI 稿 219×48 胶囊居中,#26C5AB
  ctaWrap: {
    position: 'absolute',
    left: 0,
    right: 0,
    // 48 是设计稿数值(CTA 底边距画板底 48pt),刚好让开 <video controls> 的原生控件条 ——
    // 24 的时候实测两者叠在一起
    bottom: 'calc(48px + env(safe-area-inset-bottom, 0px))',
    display: 'flex',
    justifyContent: 'center',
  },
  cta: {
    width: CTA_WIDTH, // 与微信引导里的下载按钮共用,见常量注释
    // ⚠️ 必须 border-box:默认 content-box 下 padding 会把 251 撑成 283
    // (原来写的是 minWidth 所以没这个问题,改定宽就必须补这一行)
    boxSizing: 'border-box',
    height: 48,
    borderRadius: 24,
    background: '#26C5AB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 16px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    // CTA 是 <a>(iOS 上让用户直接点链接,universal link 才触发得稳),
    // 下划线会传给子元素且子元素去不掉,必须在这里关;color 一并定死免得吃浏览器链接色
    textDecoration: 'none',
    color: '#FFFFFF',
  },
  ctaLogo: {
    width: 28,
    height: 28,
    borderRadius: 6,
    marginRight: 10,
  },
  ctaText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: 500,
  },
  // 失效态:UI/ui_offline.png
  offlineBox: {
    position: 'absolute',
    top: '32%',
    left: 0,
    right: 0,
    textAlign: 'center',
  },
  // 失效态图标:稿子里 140×140 设计单位 ÷ density 2 = 70。圆角和降透明度都不要 ——
  // 图本身就是个圆,底板的半透明也已经烘焙在 alpha 里,再叠 opacity 会比稿子灰一层。
  offlineIcon: {
    width: 70,
    height: 70,
  },
  // 只剩加载态在用(失效态已换 offlineIcon)。appLogo 是圆角方图,这里的圆角不能去。
  loadingLogo: {
    width: 64,
    height: 64,
    borderRadius: 14,
    opacity: 0.9,
  },
  offlineText: {
    marginTop: 20,
    color: '#FFFFFF',
    fontSize: 17,
  },
  offlineSub: {
    marginTop: 10,
    color: 'rgba(255,255,255,0.6)',
    fontSize: 14,
  },
  // 引导蒙层(UI 未画,按通用样式)
  guideMask: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.72)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    zIndex: 99,
  },
  guideBox: {
    background: '#FFFFFF',
    borderRadius: 12,
    padding: '24px 20px',
    textAlign: 'center',
    maxWidth: 300,
  },
  // 微信引导(满屏):整张稿铺在左上，按钮排在它下面
  wechatGuide: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  // 整张稿放在右上角，不铺满屏宽。230 宽时箭头约 58、标题字高约 17。
  // 改尺寸时高度要按 542×245 等比跟着算(height = width * 245 / 542)。
  wechatGuideImg: {
    position: 'absolute',
    top: 0,
    // 箭头尖就在图的右上角(原图 541,1 / 共 542×245),所以图往左挪多少、尖就偏多少。
    // 让尖端落到微信导航栏「···」的正下方。24 实测还偏右,加到 40。
    right: 40,
    width: 230,
    height: 104, // 230 * 245 / 542
    maxWidth: '100%',
  },
  // 按钮放屏幕底部，与页面原本那个「打开 App 看更多科普」吸底 CTA 同一位置(距底 48):
  // 用户刚点的就是那儿，蒙层弹出后按钮出现在原地，手指不用挪。
  // 排在引导图下方试过，按钮会孤零零飘在左上方、周围没有任何东西锚定它。
  // 与页面原本那个吸底 CTA **完全同一套定位**(见 ctaWrap):同样的 48 + 安全区、同样居中。
  // 之前只写 bottom:48、漏了 env(safe-area-inset-bottom),在刘海屏上会和它差一截。
  wechatGuideBtnWrap: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 'calc(48px + env(safe-area-inset-bottom, 0px))',
    display: 'flex',
    justifyContent: 'center',
  },
  guideTitle: {
    color: '#333333',
    fontSize: 17,
    fontWeight: 600,
  },
  guideText: {
    marginTop: 12,
    color: '#666666',
    fontSize: 14,
    lineHeight: '20px',
  },
  guideBtn: {
    marginTop: 24,
    maxWidth: 260,
    height: 44,
    lineHeight: '44px',
    borderRadius: 22,
    background: '#26C5AB',
    color: '#FFFFFF',
    fontSize: 16,
    // ⚠️ 必须自己写 textAlign:以前它在 guideBox 白卡片里,靠那层的 textAlign:'center' 继承;
    // 挪到满屏引导(wechatTextBlock 左对齐)之后继承源没了,文字会贴到 x=0,
    // 再被 22 的圆角切掉半个字(2026-09-10 真机截图发现)。
    textAlign: 'center',
    padding: '0 16px',
    boxSizing: 'border-box',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}



// WEBPACK FOOTER //
// ./src/modules/videoShare/components/index.js